import {makeStyles} from "tss-react/mui";

export const useSearchStyles = makeStyles()((theme) => ({
  noPrint: {
    "@media print": {
      display: "none",
    },
  },
}));
